export default __webpack_public_path__ + "static/media/settings.2f8dff36.svg";